const structuralMoulageLocations = [
  {
    key: 'TORSO',
    label: {
      en: 'Torso',
      es: 'Torso',
    },
  },
  {
    key: 'RIGHT_ARM',
    label: {
      en: 'Right Arm',
      es: 'Right Arm',
    },
  },
  {
    key: 'LEFT_ARM',
    label: {
      en: 'Left Arm',
      es: 'Left Arm',
    },
  },
  {
    key: 'RIGHT_LEG',
    label: {
      en: 'Right Leg',
      es: 'Right Leg',
    },
  },
  {
    key: 'LEFT_LEG',
    label: {
      en: 'Left Leg',
      es: 'Left Leg',
    },
  },
  {
    key: 'HEAD',
    label: {
      en: 'Head',
      es: 'Head',
    },
  },
];

module.exports = structuralMoulageLocations;
